/**
 * 前端防爬工具
 */

// 图片懒加载 + 防盗链处理
export function processImageURL (url) {
  if (!url) return ''

  // 如果已经是签名 URL，直接返回
  if (url.includes('/api/proxy/image')) {
    return url
  }

  // 否则返回原 URL（后端会处理签名）
  return url
}

// 禁用图片右键保存和拖拽
export function disableImageContextMenu () {
  // 禁用右键菜单
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  }, true)

  // 禁用拖拽
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  }, true)

  // 禁用选择文本（对图片容器）
  document.addEventListener('selectstart', (e) => {
    const target = e.target
    // 检查 target 是否是 Element 且有 closest 方法
    if (target && typeof target.closest === 'function' && target.closest('.image-container, .article-image, img')) {
      e.preventDefault()
      return false
    }
  }, true)

  // 禁用复制
  document.addEventListener('copy', (e) => {
    const target = e.target
    // 检查 target 是否是 Element 且有 closest 方法
    if (target && (target.tagName === 'IMG' || (typeof target.closest === 'function' && target.closest('.image-container, .article-image')))) {
      e.preventDefault()
      return false
    }
  }, true)

  // 禁用 F12 和开发者工具快捷键（简单防护）
  document.addEventListener('keydown', (e) => {
    // 禁用 F12
    if (e.key === 'F12') {
      e.preventDefault()
      return false
    }
    // 禁用 Ctrl+Shift+I (Chrome DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
      return false
    }
    // 禁用 Ctrl+Shift+J (Chrome Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
      return false
    }
    // 禁用 Ctrl+U (查看源代码)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
  }, true)
}

// 添加图片水印（可选）
export function addImageWatermark (imgElement) {
  if (!imgElement) return

  // 创建水印 canvas
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const img = new Image()

  img.crossOrigin = 'anonymous'
  img.onload = function () {
    canvas.width = img.width
    canvas.height = img.height
    ctx.drawImage(img, 0, 0)

    // 添加水印文字
    ctx.fillStyle = 'rgba(255, 255, 255, 0.3)'
    ctx.font = '20px Arial'
    ctx.fillText('ImageAI', canvas.width - 100, canvas.height - 20)

    // 替换原图片
    imgElement.src = canvas.toDataURL()
  }

  img.src = imgElement.src
}

// 检测并阻止常见的爬虫行为
export function detectScraping () {
  let suspicious = false
  const warnings = []

  // 1. 检测无头浏览器特征
  if (navigator.webdriver) {
    warnings.push('检测到自动化工具')
    suspicious = true
  }

  // 2. 检测窗口大小异常（可能是无头浏览器）
  if (window.outerHeight === 0 || window.outerWidth === 0) {
    warnings.push('检测到异常窗口大小')
    suspicious = true
  }

  // 3. 检测插件数量（无头浏览器通常插件很少）
  if (navigator.plugins.length === 0 && navigator.userAgent.indexOf('Chrome') > -1) {
    warnings.push('检测到异常插件数量')
    suspicious = true
  }

  // 4. 检测语言设置（无头浏览器可能缺少）
  if (!navigator.language && !navigator.languages) {
    warnings.push('检测到异常语言设置')
    suspicious = true
  }

  // 5. 检测 Chrome 对象（真实浏览器有）
  if (navigator.userAgent.indexOf('Chrome') > -1 && !window.chrome) {
    warnings.push('检测到伪造的 Chrome')
    suspicious = true
  }

  // 6. 检测 Permissions API（无头浏览器可能不支持）
  if (navigator.permissions && typeof navigator.permissions.query === 'function') {
    navigator.permissions.query({ name: 'notifications' }).catch(() => {
      warnings.push('检测到异常的 Permissions API')
      suspicious = true
    })
  }

  // 7. 检测 WebGL 渲染器（无头浏览器可能不同）
  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    if (gl) {
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
      if (debugInfo) {
        const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
        // 某些无头浏览器的渲染器信息可能异常
        if (renderer && (renderer.indexOf('SwiftShader') > -1 || renderer.indexOf('Software') > -1)) {
          warnings.push('检测到可疑的 WebGL 渲染器')
          // 不直接标记为可疑，因为某些正常环境也可能使用
        }
      }
    }
  } catch (e) {
    // WebGL 不可用可能是正常情况
  }

  // 8. 检测鼠标和键盘事件（爬虫通常不会触发）
  let hasUserInteraction = false
  const interactionEvents = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'click']
  interactionEvents.forEach(eventType => {
    document.addEventListener(eventType, () => {
      hasUserInteraction = true
    }, { once: true })
  })

  // 如果检测到可疑行为，记录并可能限制功能
  if (suspicious && warnings.length > 0) {
    console.warn('[AntiScrape] 检测到可疑行为:', warnings)
    // 可以在这里执行操作，比如：
    // - 限制某些功能
    // - 要求验证码
    // - 记录到后端
  }

  return { suspicious, warnings, hasUserInteraction }
}

// 请求频率限制（前端辅助）
let requestCount = 0
let requestWindow = Date.now()

export function checkRequestRate (maxRequests = 60, windowMs = 60000) {
  const now = Date.now()

  if (now - requestWindow > windowMs) {
    requestCount = 0
    requestWindow = now
  }

  requestCount++

  if (requestCount > maxRequests) {
    console.warn('请求过于频繁，请稍后再试')
    return false
  }

  return true
}

// 添加图片保护层（防止直接访问）
export function protectImages () {
  // 为所有图片添加保护
  const images = document.querySelectorAll('img')
  images.forEach(img => {
    // 添加 data 属性标记
    img.setAttribute('data-protected', 'true')

    // 监听图片加载错误（可能是防盗链）
    img.addEventListener('error', function () {
      console.warn('[AntiScrape] 图片加载失败，可能是防盗链保护')
    })

    // 防止图片被直接访问
    img.addEventListener('load', function () {
      // 可以在这里添加水印或其他保护措施
    })
  })

  // 使用 MutationObserver 监听新添加的图片
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'IMG') {
            node.setAttribute('data-protected', 'true')
          }
          // 检查子元素中的图片
          const imgs = node.querySelectorAll && node.querySelectorAll('img')
          if (imgs) {
            imgs.forEach(img => {
              img.setAttribute('data-protected', 'true')
            })
          }
        }
      })
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

// 检测并阻止控制台打开
export function detectDevTools () {
  let devtools = { open: false, orientation: null }
  const threshold = 160

  setInterval(() => {
    if (window.outerHeight - window.innerHeight > threshold ||
        window.outerWidth - window.innerWidth > threshold) {
      if (!devtools.open) {
        devtools.open = true
        console.warn('[AntiScrape] 检测到开发者工具已打开')
        // 可以在这里执行操作，比如：
        // - 清除敏感数据
        // - 跳转到其他页面
        // - 记录日志
      }
    } else {
      if (devtools.open) {
        devtools.open = false
      }
    }
  }, 500)
}

// 初始化防爬功能
export function initAntiScrape () {
  // 禁用图片右键和拖拽
  disableImageContextMenu()

  // 保护图片
  protectImages()

  // 检测爬虫行为
  const detection = detectScraping()

  // 检测开发者工具
  detectDevTools()

  // 定期检测
  setInterval(() => {
    detectScraping()
  }, 5000)

  // 在页面可见性变化时检测
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      // 页面隐藏时，可能是自动化工具在后台运行
      console.warn('[AntiScrape] 页面已隐藏')
    }
  })

  return detection
}
